import { ExtractedData } from "./extract-financial-indicator-data";
import { customizeDatasetStyles } from "@/helpers/financial-indicator/dataset-styles";
import { ChartKey, ChartType } from "@/types/chart";
import { ChartData } from "chart.js";

export const transformFinancialIndicatorData = ({
  extractedData,
  chartType,
  chartKey,
}: {
  extractedData: ExtractedData;
  chartType: ChartType;
  chartKey: ChartKey;
}): ChartData<Exclude<typeof chartType, "area">> => {
  const { labels, values } = extractedData;
  const datasetStyles = customizeDatasetStyles({ chartKey });

  switch (chartType) {
    case "bar":
      return {
        labels,
        datasets: values.map(({ key, value }, index) => ({
          label: key,
          data: value,
          ...datasetStyles({ index }).bar,
        })),
      };
    case "line":
    case "area":
      return {
        labels,
        datasets: values.map(({ key, value }, index) => ({
          spanGaps: true,
          label: key,
          data: value,
          ...datasetStyles({ index }).line,
        })),
      };

    default:
      throw new Error(`Unsupported chart type: ${chartType}`);
  }
};
